import { DragIndicator } from '@mui/icons-material';
import { styled, Typography } from '@mui/material';
import { Row } from 'components/Layout';

type Props = {
  label: string;
  index: number;
};

const Item = styled(Row)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: theme.spacing(2),
  borderRadius: theme.shape.borderRadius,
  borderLeft: `2px solid ${theme.palette.primary.main}`,
  boxShadow: '2px 20px 40px 0px rgba(235, 235, 236, 1)',
  backgroundColor: theme.palette.common.white,
}));

const WaterfallStructureItem: React.FC<Props> = ({ label, index }) => {
  return (
    <Row centered justify="space-between" spacing="sm">
      <Typography variant="body2" fontWeight={700} color="text.secondary">
        {index + 1}
      </Typography>
      <Item centered justify="space-between" fullWidth>
        <span>{label}</span>
        <DragIndicator color="primary" />
      </Item>
    </Row>
  );
};

export default WaterfallStructureItem;
